export const isCacheableConversationQuery = filters =>
  (typeof window === 'undefined' || window.chatwootConfig?.conversationListCache !== false) &&
  !filters.conversationType && !filters.updatedWithin && !filters.queryData && !filters.q;

export const makeConversationQueryKey = (context, filters) => JSON.stringify([
  context.identityEpoch || 0, context.permissionsEpoch || 0,
  context.accountId, context.userId,
  filters.inboxId == null ? null : String(filters.inboxId),
  filters.teamId == null ? null : String(filters.teamId),
  [...new Set(filters.labels || [])].sort(),
  filters.assigneeType || 'all', filters.status || 'open',
  filters.sortBy || 'latest', filters.conversationType || null,
]);
